module.exports = __webpack_public_path__ + "img/CAT_CHEMICAL_GAS.f86b3a0f.svg";